/** 储存方式 */
export enum STORAGE_TYPE_EMUN {
  /** 常温 */
  'homoeothermy' = 1,
  /** 空调 */
  'ac',
  /** 冷冻 */
  'freezing',
  /** 冷藏 */
  'refrigeration',
}
export const STORAGE_TYPE = [
  {
    value: STORAGE_TYPE_EMUN['homoeothermy'],
    label: 'enums.storageType.1',
  },
  {
    value: STORAGE_TYPE_EMUN['ac'],
    label: 'enums.storageType.2',
  },
  {
    value: STORAGE_TYPE_EMUN['freezing'],
    label: 'enums.storageType.3',
  },
  {
    value: STORAGE_TYPE_EMUN['refrigeration'],
    label: 'enums.storageType.4',
  },
]
